import { getToken } from "@/utils/index";
// import NProgress from 'nprogress'
import { userInfoStore } from "@/store/userInfo";
import { permissionStore } from "@/store/permission";
import router from "@/router";
import { authPermi, authRole } from "@/utils/hasAuth";
import { RouteLocationNormalized, NavigationGuardNext } from "vue-router";
import { ResponseData } from "@/interface/userInfo";
import { userIndex } from "@/store/userindex";
import { appConfigStore } from "@/store/appconfig";
import registerStore from "@/store/register";
import { removeItemFromPath } from "@/store/plugins/storage";
import { removeToken } from "@/utils";
import { outDateSkip } from "@/utils/public";
import { showToast } from "vant";
import { getStorage } from "@/utils/auth";
// NProgress.configure({ showSpinner: false })

const whiteList = ["/", "/login", import.meta.env.VITE_APP_ACCOUNT_LOGIN_PAGE, "/tree", "/auth-redirect", "/401", "/404", "/register"];
// 定时器解决页面需要刷新才能进入的问题
router.afterEach((to) => {
  setTimeout(() => {
    if (document.body) {
      console.log("有body");
      const el = document.querySelector("#app");
      if (!el?.getElementsByClassName("window-container")[0].children.length) {
        console.log("indow-container有长度");
        if (getToken()) {
          removeToken();
        }
        userIndex()?.clearData();
        permissionStore()?.clearData();
        userInfoStore()?.destoryInfo();
        setTimeout(() => {
          window.location.reload();
        }, 800);
      }
    }
  }, 2000);

  if (to.meta && to.meta.title) {
    window.document.title = to.meta.title || window._globalConfig?.rootNodeName || import.meta.env.VITE_APP_TITLE;
  }
  if (to.meta && to.meta.isBuriedPoint === "0") {
    if (window._paq && window._paq.push) {
      window._paq.push(["setDocumentTitle", window.location.hash]);
      window._paq.push(["trackPageView"]);
    }
  }
  // NProgress.done()
});

router.beforeEach((to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
  // NProgress.start()
  if (!window._globalConfig) {
    registerStore().getConfigInfo();
  }
  let tokenKey = getToken();
  if (tokenKey) {
    if (whiteList.includes(to.path)) {
      next({ path: "/index" });
      // NProgress.done()
    } else {
      // console.log("to", to);
      removeItemFromPath(from.path);
      if (whiteList.includes(to.path)) {
        next();
        // NProgress.done()
      } else {
        const userInfo = userInfoStore();
        if (userInfo.userInfo) {
          next();
        } else {
          userInfo
            .getuserInfo()
            .then((info: ResponseData) => {
              permissionStore()
                .generateRoutes()
                .then((result) => {
                  appConfigStore().init();
                  if (info.permissions) {
                    authPermi("*:*:*", info.permissions);
                  }
                  if (info.roles) {
                    authRole("admin", info.roles);
                  }

                  result.forEach((element: any) => {
                    if (element.path && !element.path.includes("http")) {
                      router.addRoute(element);
                    }
                  });
                  userInfo
                    .getMineInfoFun()
                    .then(() => {
                      next({ ...to, replace: true });
                    })
                    .catch(async (err) => {
                      try {
                        await userInfo.loginOut();
                        // window.location.href = window.location.origin + window.location.pathname + "#/index";
                      } catch (error) {
                        console.log("登出接口报错1", error);
                      }
                      next({ path: window.VITE_APP_LOGIN_PAGE || import.meta.env.VITE_APP_LOGIN_PAGE });
                    });
                })
                .catch(async (err) => {
                  console.error(err, "获取路由信息报错");
                  try {
                    await userInfo.loginOut();
                  } catch (error) {
                    console.log("登出接口报错2", error);
                  }
                  next({ path: window.VITE_APP_LOGIN_PAGE || import.meta.env.VITE_APP_LOGIN_PAGE });
                });
            })
            .catch(async (err) => {
              console.error(err, "获取用户信息报错");
              try {
                await userInfo.loginOut();
              } catch (error) {
                console.log("登出接口报错3", error);
              }
              next({ path: window.VITE_APP_LOGIN_PAGE || import.meta.env.VITE_APP_LOGIN_PAGE });
            });
        }
      }
    }
  } else {
    userInfoStore()?.destoryInfo();
    permissionStore()?.clearData();
    userIndex()?.clearData();

    if (whiteList.includes(to.path)) {
      next();
    } else {
      // outDateSkip();
      // if (window.location.hash != "/#" + (window.VITE_APP_LOGIN_PAGE || import.meta.env.VITE_APP_LOGIN_PAGE)) {
      //   window.location.href = window.location.origin + "/#" + (window.VITE_APP_LOGIN_PAGE || import.meta.env.VITE_APP_LOGIN_PAGE);
      // }
      if (getStorage("loginType") == "sso") {
        next({ path: import.meta.env.VITE_APP_LOGIN_PAGE });
      } else {
        next({
          path: import.meta.env.VITE_APP_ACCOUNT_LOGIN_PAGE
          // query: {
          //   redirect: to.fullPath
          // }
        });
      }

      // NProgress.done()
    }
  }
});

router.onError((err) => {
  console.log(err);
});
